import { onAllClick, scrollToElement, isAdmin, } from "./helpers";
export default (function () {
    // auto-scrolling
    if (window.location.hash) {
        history.scrollRestoration = "manual";
        var target = document.querySelector(window.location.hash);
        if (target) {
            scrollToElement(target);
        }
    }
    // else if (history.scrollRestoration != "manual") {
    //     history.scrollRestoration = "auto";
    // }
    onAllClick('[href^="#"]', function (e) {
        if (!isAdmin()) {
            e.preventDefault();
            e.stopPropagation();
            try {
                var anchor = e.target.closest('a');
                if (anchor) {
                    var url = document.createElement('a');
                    url.href = anchor.getAttribute('href') || '';
                    var hash = url.hash;
                    var target = document.querySelector(hash);
                    if (target) {
                        scrollToElement(target);
                    }
                }
            }
            catch (e) {
                console.log("smooth scroll error");
            }
            return false;
        }
    });
});
